<template>
  <hm-content title="商品列表">
    <div class="table-panel flex flex-between">
      <div class="flex-1 text-right">
        <el-cascader
          v-model="searchCondition.categoryId"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="categoryFunc"
          clearable
          placeholder="请选择类目"
        ></el-cascader>
        <el-cascader
          v-model="searchCondition.attributeId"
          placeholder="请选择辅助属性"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="attributeFunc"
          clearable
        ></el-cascader>
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.keyWords"
          size="small"
          :placeholder="placeholder"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            size="small"
            style="width:100px"
            @change="selectQueryType"
            v-model="searchCondition.queryType"
          >
            <el-option label="商品名" value="spu_name"></el-option>
            <el-option label="货号" value="goods_sn"></el-option>
            <el-option label="条码" value="spec_barcode"></el-option>
            <el-option label="品牌名" value="brand_name"></el-option>
          </el-select>
        </el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output(allMallGoodsList, 'brandTable', '门店商品列表')"
          :loading="isOutputing"
          >导出</el-button
        >
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="brandTable"
        :data="mallGoodsList.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          label="商品名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsSnAndBarcode"
          show-overflow-tooltip
          label="商品编码/条码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="商品类目(所属末级)"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="recommendedRetailPrice"
          label="零售价"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="recommendedRetailPrice"
          label="会员价"
        ></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="salesState"
          label="状态"
        >
          <template slot-scope="scope">
            <span
              class="status danger"
              v-show="scope.row.salesState === 'close'"
              >停售</span
            >
            <span
              class="status success"
              v-show="scope.row.salesState === 'open'"
              >可售</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="300px"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="mallGoodsList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { outPutMixin } from "@/mixins/outputMixin";

export default {
  mixins: [outPutMixin],
  data() {
    return {
      placeholder: "请输入商品名",
      checkedRow: [],
      searchCondition: {
        queryType: "spu_name"
      },
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false,
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1,
                syncFlag: "erp"
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId,
                syncFlag: "erp"
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryAttrListByAddGoods", {
                syncFlag: "erp"
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.valueId;
                  v.label = v.attributeValue;
                });
                resolve(res.result);
              });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId,
                syncFlag: "erp"
              };
            } else {
              params = {
                attributeId: node.data.valueId,
                syncFlag: "erp"
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  created() {},
  mounted() {
    if (this.$route.query.categoryId) {
      this.searchCondition.categoryId = [this.$route.query.categoryId];
    }
    this.$store.dispatch("querySalesChannels", {
      syncFlag: "erp"
    });
    this.queryList();
  },
  computed: mapGetters(["mallGoodsList", "salesChannels", "allMallGoodsList"]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  methods: {
    selectQueryType(queryType) {
      if (queryType === "spuName") {
        this.placeholder = "请输入商品名";
      } else if (queryType === "goodsSn") {
        this.placeholder = "请输入货号";
      } else if (queryType === "specBarcode") {
        this.placeholder = "请输入条码";
      } else if (queryType === "brandName") {
        this.placeholder = "请输入品牌名";
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage,
        syncFlag: "erp"
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";
      Object.assign(params, searchCondition);
      const actionName = queryAll
        ? "queryAllMallGoodsList"
        : "queryMallGoodsList";
      return this.$store.dispatch(actionName, params);
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}

.tabs {
  .title {
    color: #222222;
    padding-left: 10px;
  }
  .tips {
    color: #666;
    font-size: 12px;
    padding-left: 10px;
  }
}
.tips {
  color: #999;
  font-size: 14px;
}
</style>
